/* ============================================================
   artvision® · Kunst verkaufen · Häufige Fragen
   Kategorien links schalten die Gruppe rechts um, Fragen klappen
   einzeln auf. Das Markup liefert alles offen aus — erst dieses
   Skript blendet aus. Ohne JavaScript bleibt jede Antwort
   lesbar, statt hinter einem toten Schalter zu verschwinden.
   ============================================================ */
(function () {
  function init(root) {
    var cats = Array.prototype.slice.call(root.querySelectorAll('[data-av-faq-cat]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-av-faq-group]'));
    if (!groups.length) return;

    function show(key) {
      groups.forEach(function (group) {
        group.hidden = group.getAttribute('data-av-faq-group') !== key;
      });
      cats.forEach(function (cat) {
        var on = cat.getAttribute('data-av-faq-cat') === key;
        cat.setAttribute('aria-selected', on ? 'true' : 'false');
        cat.setAttribute('tabindex', on ? '0' : '-1');
      });
    }

    cats.forEach(function (cat) {
      cat.addEventListener('click', function () {
        show(cat.getAttribute('data-av-faq-cat'));
      });

      cat.addEventListener('keydown', function (event) {
        var step = 0;
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') step = 1;
        if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') step = -1;
        if (!step) return;
        event.preventDefault();
        var next = cats[(cats.indexOf(cat) + step + cats.length) % cats.length];
        next.focus();
        show(next.getAttribute('data-av-faq-cat'));
      });
    });

    function toggle(button, open) {
      var answer = document.getElementById(button.getAttribute('aria-controls'));
      var sign = button.querySelector('[data-av-faq-sign]');
      if (!answer) return;
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      answer.hidden = !open;
      if (sign) sign.textContent = open ? '−' : '+';
    }

    groups.forEach(function (group) {
      var buttons = Array.prototype.slice.call(group.querySelectorAll('[data-av-faq-q]'));
      buttons.forEach(function (button, i) {
        // Erste Frage jeder Gruppe bleibt offen, wie im Entwurf.
        toggle(button, i === 0);
        button.addEventListener('click', function () {
          toggle(button, button.getAttribute('aria-expanded') !== 'true');
        });
      });
    });

    if (cats.length) show(cats[0].getAttribute('data-av-faq-cat'));
  }

  function boot() {
    document.querySelectorAll('[data-av-faq]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
